import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { dayToJSDate } from '@shared/dates'
import format from 'date-fns/format'
import { Fragment } from 'react'

export interface TRequestDate {
  startDate: string
  endDate: string
  startTime?: string | null
  endTime?: string | null
}

export const RequestDates = ({ requestDates }: { requestDates?: TRequestDate[] }) => {
  if (!requestDates || requestDates.length === 0) {
    return null
  }

  return (
    <Box pt={3} ml={1}>
      <Typography variant="h6">Request Dates</Typography>
      <Box py={1}>
        {requestDates.map((requestDate, idx) => {
          const date = dayToJSDate(requestDate.startDate)
          if (!date) return null
          return (
            <Fragment key={requestDate.startDate}>
              <Typography variant="body1" component="span">
                {format(date, 'MMM dd')}
              </Typography>
              {requestDates.length > 0 && idx < requestDates.length - 1 && <span>,&nbsp;</span>}
            </Fragment>
          )
        })}
      </Box>
    </Box>
  )
}
